import { useQuery } from "@apollo/client";
import React from "react";
import { Link } from "@reach/router";
import MaterialTable, { Column } from "@material-table/core";
import { Grid } from "@material-ui/core";
import PhoneNumber from "components/phone-number/phone-number";
import { InterestListUsers,
  InterestListUsers_interestListUsers as UserType } from "types/gql-types";
import { QUERY_INTEREST_LIST_USERS } from "./query";


interface Props {
  path: string;
  listId: string;
  isAdmin?: boolean;
  isSupervisor?: boolean;
}

const TeamMembers: React.FC<Props> = ({ listId, isAdmin = false, isSupervisor = false }) => {
  const query = useQuery<InterestListUsers>(QUERY_INTEREST_LIST_USERS, {
    variables: { id: listId },
    fetchPolicy: "network-only",
  });

  if (query.error || query.loading || !query.data) return null;

  const columns: Array<Column<UserType>> = [
    { title: "Full Name",
      field: "fullName",
      render: ({ fullName, id }) => {
        let name = fullName;
        if (!fullName || fullName.trim() === "") name = "No Name";

        if (isSupervisor || isAdmin) {
          return <Link to={`/dash/manager/settings/team/${id}`}>{name}</Link>;
        }
        return name;
      } },
    { title: "Email", field: "email" },
    { title: "Phone", field: "directPhone", render: ({ directPhone }) => <PhoneNumber number={directPhone || ""}/> },
  ];

  return <MaterialTable<UserType>
    components={{ Container: Grid }}
    options={{
      showTitle: false,
      padding: "dense",
    }}
    columns={columns}
    data={query.data.interestListUsers}
  />;
};

export default TeamMembers;
